import React, { useState, useCallback } from 'react';
import { StyledButton } from "components/Buttons/DefaultButton/DefaultButton.styles";
import { SimpleModal } from '../../../../components/Modal';
import dayjs from 'dayjs';
import styles from '../CustomOfferDetailsPage.module.css';
import {JobProps} from "utils/types";

interface BookAnotherTempProps {
  job: JobProps
}

// @ts-ignore
const TempStars = window.TempStars;


const BookAnotherTemp: React.FC<BookAnotherTempProps> = ({ job }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handlePostNewJob = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const handleConfirmPostNewJob = useCallback(() => {
    setIsModalOpen(false);
    // @ts-ignore
    TempStars.Pages.Dentist.Home.getTempHandler(null, { date: dayjs(job?.startDate).toDate() });
  }, [job?.startDate]);

  return (
    <>
      <StyledButton
        variant="contained"
        color="primary"
        size="small"
        id="continue-button"
        className={styles.bookAnotherButton}
        onClick={handlePostNewJob}
      >
        Book Another Temp For This Date
      </StyledButton>
      <SimpleModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <h2>Book Another Shift?</h2>
        <p>Do you need another temp for this day?</p>
        <p>{dayjs(job?.startDate).format('MMMM D, YYYY')}</p>
        <div>
          <StyledButton
            variant="contained"
            color="primary"
            onClick={handleConfirmPostNewJob}
          >
            YES
          </StyledButton>
          <StyledButton
            variant="outlined"
            onClick={() => setIsModalOpen(false)}
          >
            No
          </StyledButton>
        </div>
      </SimpleModal>
    </>
  );
};

export default BookAnotherTemp;